interface ShortlistPaletteOptions {
  main: string;
  text: string;
}

interface ShortlistPalette {
  recommended: ShortlistPaletteOptions;
  shortlisted: ShortlistPaletteOptions;
  default: ShortlistPaletteOptions;
}

export interface Shortlist {
  air: ShortlistPalette;
  accommodation: ShortlistPalette;
  vehicle: ShortlistPalette;
  transfer: ShortlistPalette;
}

export const shortlist = {
  air: {
    recommended: {
      main: '#E81E8A',
      text: '#FFFFFF',
    },
    shortlisted: {
      main: '#3E4B51',
      text: '#FFFFFF',
    },
    default: {
      main: '#F5F5F5',
      text: '#777777',
    },
  },
  accommodation: {
    recommended: {
      main: '#A927B0',
      text: '#FFFFFF',
    },
    shortlisted: {
      main: '#3E4B51',
      text: '#FFFFFF',
    },
    default: {
      main: '#F5F5F5',
      text: '#777777',
    },
  },
  vehicle: {
    recommended: {
      main: '#001FC0',
      text: '#FFFFFF',
    },
    shortlisted: {
      main: '#3E4B51',
      text: '#FFFFFF',
    },
    default: {
      main: '#F5F5F5',
      text: '#777777',
    },
  },
  transfer: {
    recommended: {
      main: '#3B5569',
      text: '#FFFFFF',
    },
    shortlisted: {
      main: '#3E4B51',
      text: '#FFFFFF',
    },
    default: {
      main: '#F5F5F5',
      text: '#777777',
    },
  },
};
